import { TransactionType } from '@/types';
import { StepArchetype } from '@/types/stepRun';

export enum WorkflowRunUpdatable {
    TriggerBatchAction = 'TriggerBatchAction',
    PingPendingChecklistItemsForStepGroup = 'PingPendingChecklistItemsForStepGroup',
    BulkMarkCLIsAsCompleted = 'BulkMarkCLIsAsCompleted',
}

export interface TriggerBatchActionRequest {
    targetStepRunIds: string[];
    transactionType: TransactionType;
    stepArchetype: StepArchetype;
    customRequestData: any;
}

export interface PingPendingChecklistItemsForStepGroupRequest {
    stepRunIds: string[];
    stepArchetype: StepArchetype;
}

export interface BulkMarkCLIsAsCompletedRequest {
    stepRunIds: string[];
}
